window.isNoneClicked = false;
function addNoneProduct(input, id, price) {
    setTimeout(() => {
        // document.querySelector(".custom-price").value = input.closest(".product-detail").querySelector("[data-product-price] span").textContent;
        // document.querySelector(".custom-id").value = input.closest(".product-detail").querySelector("select[name=id]").value;
        input.closest(".product-detail").querySelector("[data-product-price] span").textContent = price;
        // input.closest(".product-detail").querySelectorAll("[name=id] option").forEach(function (option) {
        //     if (option.hasAttribute("selected")) {
        //         option.setAttribute("value", id);
        //     }
        // })

        // input.closest(".product-detail").querySelector("input[name=id]").value = id;
        input.closest(".product-detail").querySelector(".custom-image").value = input.closest(".product-layout-grid").querySelector(".thumb-active").getAttribute("data-media-id");
        document.querySelectorAll('[alt="None"]').length ? document.querySelectorAll('[alt="None"]')[1].click() : "";
        window.isNoneClicked = true;
    }, 300);

}

document.querySelectorAll(".product-detail__options label").forEach(function (input) {
    input.addEventListener("click", function () {
        var label = this;
        if (window.isNoneClicked) {
            label.previousElementSibling.closest(".product-detail").querySelector("[data-product-price] span").textContent = document.querySelector(".custom-price").value;
        }

        window.isNoneClicked = false;
        setTimeout(() => {
            if (label.previousElementSibling.classList.contains('noneProduct')) {
                document.querySelectorAll(".product-detail__options.row .row.js")[1].style.display = 'none';
            } else {
                var noneProduct = document.querySelector(".noneProduct");

                if (noneProduct.parentElement.querySelectorAll("input")[0].checked) {
                    noneProduct.value = noneProduct.parentElement.querySelectorAll("input")[1].value;
                } else {
                    noneProduct.value = noneProduct.parentElement.querySelectorAll("input")[0].value;
                }


                document.querySelectorAll(".product-detail__options.row .row.js")[1].style.display = 'block';

                // label.previousElementSibling.closest(".product-detail").querySelectorAll("[name=id] option").forEach(function (option) {
                //     option.setAttribute("value", option.getAttribute('data-value'));
                // })

                var NoneProductImageId = document.querySelectorAll('[alt="None"]').length ? document.querySelectorAll('[alt="None"]')[1].closest("a.product-detail__thumbnail").getAttribute("data-media-id") : ""

                if (label.previousElementSibling.closest(".product-layout-grid").querySelector(".thumb-active").getAttribute("data-media-id") == NoneProductImageId && NoneProductImageId != "") {
                    label.previousElementSibling.closest(".product-layout-grid").querySelector(".product-detail__thumbnail[data-media-id='" + label.previousElementSibling.closest(".product-detail").querySelector(".custom-image").value + "']").click();
                }


            }
        }, 200);
    })
});

if (document.querySelector(".noneProduct")) {
    var noneProduct = document.querySelector(".noneProduct");
    noneProduct.value = noneProduct.parentElement.querySelector("input:checked").value;
}